<template>
  <div class="search-result-for-contacts" v-show="show">
    <!-- Result list -->
    <ul class="sr-list" v-show="results.length > 0 && !addContact">
      <li
        class="cursor-pointer"
        v-for="result in results"
        :key="result.type + '.' + result.id"
        @click="selectOption({ type: result.type, id: result.id })"
        v-html="result.name"
      ></li>
    </ul>

    <!-- When no data is found -->
    <contact-not-found
      v-if="results.length <= 0 || addContact"
      :term="term"
      :empty-term="emptyTerm"
      :option-selected="addOptionSelected"
      :toggle-full-result-list="toggleFullResultList"
      :show-full-result-list="showFullResultList"
    />
  </div>
</template>

<script>
import ContactNotFound from "./ContactNotFound";
import { listMixin } from "../../../../../mixins/listMixin";

export default {
  name: "AddAppointmentResultList",
  mixins: [listMixin],
  props: {
    show: Boolean, // Show the list or not
    term: String, // The term that we are trying to search
    hideResult: Function, // Hides the result
    emptyTerm: Function, // Empties the search term
    addOptionSelected: Function, // When add client/person/event/group option is selected
    addContact: Boolean, // Wheather to show the add contact or not
    toggleFullResultList: Function, // Show the full result list
    showFullResultList: Boolean // Weather to show the full result list
  },
  components: {
    ContactNotFound // Contact not found component
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
